import React from "react";
import { FormComponent } from "../../../../../../react-core/Html/FormComponent";
import { PartLoading } from "../../../../../../react-core/Html/PartLoading";
import { UserClaim } from "../../../../../../Wrap/Constants/Enums/UserClaim";
import { NotificationConfigurationModel } from "../../../../../../Wrap/Models/Domains/Threads/NotificationConfigurationModel";
import { checkPermission } from "../../../../../Shared/Permission/PermissionHelper";
import { NotificationAction } from "../../Action/NotificationAction";
import { EmailNotification } from "./EmailNotification";
import { ExistingNotifications } from "./ExistingNotifications";
import { NewNotification } from "./NewNotification";
import { Alert } from "../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../Shared/Entities/Constants/AlertConstants";
import { UserEmailAlertPreferences } from "../../../../../../Wrap/Models/Domains/Threads/UserEmailAlertPreferences";

interface INotificationConfigurationsProps {
    onCancel: () => void;
    onApply: (v) => void;
}

interface INotificationConfigurationsState {
    isLoading: boolean;
    hasFirmLevelPermission: boolean;
    model: NotificationConfigurationModel;
    userEmailAlertPreferences: Array<UserEmailAlertPreferences>;
    AllAdvisorSelected?:boolean;
}

export class NotificationConfigurations extends FormComponent<
    INotificationConfigurationsProps,
    INotificationConfigurationsState
> {
    constructor(props: any) {
        super(props);
        this.state = {
            isLoading: false,
            userEmailAlertPreferences: [],
            hasFirmLevelPermission: false,
            model: null,
            AllAdvisorSelected:false
        };
    }

    componentDidMount() {
        this.setState({
            isLoading: true,
            hasFirmLevelPermission: checkPermission(UserClaim.AdviserPortalFirmLevelNotificationReadWrite),
        });

        Promise.all([
            new Promise((resolve) => {
                NotificationAction.getNotificationConfiguration((result) => {
                    resolve(result);
                });
            }),
            new Promise((resolve) => {
                NotificationAction.getEmailNotificationPreferences((result) => {
                    resolve(result);
                });
            })
        ]).then(([notificationConfig, emailPreferences]) => {
            this.setState({ 
                model: notificationConfig, 
                userEmailAlertPreferences: emailPreferences as UserEmailAlertPreferences[], 
                isLoading: false 
            });
        });
        
    }

    private loadNotificationConfigurationModel() {
        this.setState({ isLoading: true });

        NotificationAction.getNotificationConfiguration((result) => {
            this.setState({ model: result, isLoading: false });
        });
    }

    private loadEmailNotificationPreferences() {
        this.setState({ isLoading: true });

        NotificationAction.getEmailNotificationPreferences((result) => {
            this.setState({ userEmailAlertPreferences: result, isLoading: false });
        });
    }

    private setAdvisorSelection(value:boolean){
        this.setState({AllAdvisorSelected:value})
    }

    public render(): JSX.Element {
        const { model, hasFirmLevelPermission, isLoading } = this.state;
        if(model){
        var modelCopy = { ...model };
        const mandatoryCategory = {
            Id: model.Categories.length + 1, 
            Name: 'Mandatory',
        };
        modelCopy.Categories = [mandatoryCategory, ...modelCopy.Categories];
        }


        if (isLoading) {
            return <PartLoading isLoading={true} />;
        }
        return (
            <div>
                <NewNotification
                    model={modelCopy}
                    hasFirmLevelPermission={hasFirmLevelPermission}
                    onSave={() => this.loadNotificationConfigurationModel()}
                    onSetAdvisorSelection = {(value) => this.setAdvisorSelection(value)}
                />
                <hr />
                <ExistingNotifications
                    model={model}
                    AllAdvisorSelected={this.state.AllAdvisorSelected}
                    hasFirmLevelPermission={hasFirmLevelPermission}
                    onSave={() => this.loadNotificationConfigurationModel()}
                />
                <hr />
                <EmailNotification
                    model={model}
                    userEmailAlertPreferences={this.state.userEmailAlertPreferences}
                    emailConfig={model?.EmailConfiguration}
                    onSave={() => this.loadNotificationConfigurationModel()}
                    onSaveEmailSetting={() => this.loadEmailNotificationPreferences()}
                />
                <hr />
                <Alert alertType={AlertType.Warning} message={"We recommend that at least one user within your firm manages notifications and email alerts."} />
            </div>
        );
    }
}
